export const AuthLocalStorageKeys = {
    activeStudySite: 'activeStudySite',
};

export const OKTA_SSO_ROUTE_PREFIX = '/sso/okta';

//BE generated, ex: /activateUser?LinkId=User.8c8c256e-2ee2-4815-849e-5dc46732fa14
//TODO: this might not be used anymore as users with email are now created via FX
export const RESET_LINK_USER_PK_PARAM = 'LinkId';

export enum AUTH_STAGE {
    NEW_PASS_REQUIRED = 'NEW_PASS_REQUIRED',
    MFA_REQUIRED = 'MFA_REQUIRED',
    TOTP_REQUIRED = 'TOTP_REQUIRED',
    CUSTOM_CHALLENGE = 'CUSTOM_CHALLENGE',
    MFA_SETUP = 'MFA_SETUP',
    SELECT_MFA_TYPE = 'SELECT_MFA_TYPE',
}

export enum CognitoAuthErrorCode {
    NETWORK_ERROR = 'NetworkError',
    INTERNAL_ERROR = 'InternalErrorException',
    INVALID_LAMBDA = 'InvalidLambdaException',
    INVALID_PARAMETER = 'InvalidParameterException',
    INVALID_USER_POOL_CONFIGURATION = 'InvalidUserPoolConfigurationException',
    NOT_AUTHORIZED = 'NotAuthorizedException',
    PASSWORD_RESET_REQUIRED = 'PasswordResetRequiredException',
    RESOURCE_NOT_FOUND = 'ResourceNotFoundException',
    TOO_MANY_REQUESTS = 'TooManyRequestsException',
    UNEXPECTED_LAMBDA = 'UnexpectedLambdaException',
    USER_LAMBDA_VALIDATION = 'UserLambdaValidationException',
    USER_NOT_CONFIRMED = 'UserNotConfirmedException',
    USER_NOT_FOUND = 'UserNotFoundException',
    PASSWORD_UNAVAILABLE = 'PasswordUnavailable',
    OKTA_LOGIN_REQUIRED = 'OktaLoginRequired', // OR-23228 possible BE implementation in future
}
